<ng-container *ngIf="vm$ | async as vm">

  <h1 class="head1">Recente documenten</h1>

  <div class="accordeon-panel" [class.accordeon-container-active]="vm.currentPeriod==period"
    *ngFor="let period of vm.documentPeriods">
    <div class="accordeon-title-row" role="button" tabindex="0" title="{{period.Name}}" (keydown.enter)="setActivePeriodSubj.next(period)" (click)="setActivePeriodSubj.next(period)">
      <div class="accordeon-title-col">
        <h2 class="head3 title grey-txt-dark">{{period.Name}}</h2>
      </div>
      <div class="accordeon-flip-col">
        <i class="icon-arrow_dwn accordeon-indicator" [class.rotated]="vm.currentPeriod==period"></i>
      </div>
    </div>
    <div class="accordeon-period-row" *ngIf="vm.currentPeriod==period" #documentenDiv>
      <div class="document-row" *ngFor="let document of vm.documenten" [id]="'d_'+document.Id">
        
        <div>{{document.DatumUpdate | date:'dd.MM.y'}}</div>
        <div><i class="icon-pencil" [ngClass]="{'icon-pencil--invisible':document.IsNew}"></i> </div>

        <a href="#" (click)="openDocument(document)" class="document-title ">{{document.Titel}}</a>
        <a href="#" role="button" aria-label="Detail document" class="document-marker-col btn-icon btn-icon-15" (click)="showDocument(document)">
          <span *ngIf="!document.detail; else documentactive" class="document-title" [ngClass]="document.AtHomeColorClass">+</span>
          <ng-template #documentactive>
            <div class="document-title btn-icon btn-icon-15" [ngClass]="document.AtHomeColorClass"></div>
          </ng-template>
        </a>

        <div class="app-document">
          <app-document-callout *ngIf="document.detail" [detaildocument]="document.detail"></app-document-callout>
        </div>

      </div>
    </div>
  </div>
</ng-container>